<template>
  <Layout>
    <div class="tabs-container">
      <div
          class="tab"
          :class="{ active: isActiveTab === 0 }"
          @click="isActiveTab = 0"
      >
        <span>{{$t('leaderboard_list')}}</span>
      </div>
      <div
          class="tab"
          :class="{ active: isActiveTab === 1 }"
          @click="isActiveTab = 1"
      >
        <span>{{$t('tasks_title')}}</span>
      </div>
    </div>

    <div v-if="isActiveTab === 0">
      <div class="table-holder">
        <GamificationTable
            :loading="isLoading"
            :users="tableData.data"
            :current-sort="currentSort"
            :on-sort="handleSort"
            :refresh-data="() => handlePage(currentPage)"
        />
        <div class="pagination-align-center">
          <Pagination :total-items="tableData.total" :per-page="20" :current-page="currentPage" :on-page-change="handlePage"/>
        </div>
      </div>
    </div>
    <div v-else>

      <GamificationTasks
          :tasks="tasksData"
          :loading="isTasksLoading"
          :update-data="loadTasks"
          @edit="handleEditTask"
          @delete="handleDeleteTask"
          @add-success="handleTaskAddSuccess"
      />
    </div>

  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import GamificationTable from "@/components/tables/Gamification/GamificationTable.vue";
import gamificationService from "@/service/gamificationService";
import Pagination from "@/components/Pagination.vue";
import CompanyTable from "@/components/tables/Company/CompanyTable.vue";
import {handleErrorResponse} from "@/utils/utils";
import roleService from "@/service/roleService";
import GamificationTasks from "@/components/gamification/GamificationTasks.vue";

export default {
  name: 'Home',
  components: {
    GamificationTasks,
    CompanyTable,
    Pagination,
    GamificationTable,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      isLoading: true,
      data: {},
      tableData: {},
      currentPage: 1,
      roleList: [],
      isActiveTab: 0,
      isTasksLoading: true,
      tasksData: [],
      currentSort: {
        column: null,
        direction: null
      }
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    },
    isActiveTab(newVal) {
      if (newVal === 1) {
        this.loadTasks();
      }
    }
  },
  mounted() {
    this.isLoading = true;
    const user = JSON.parse(localStorage.getItem('user'));
    roleService.getStoreByCompanyRole(user.companyId).then(response => {
      this.roleList = response.data.data;
    }).catch(err => {
      handleErrorResponse(err, this.$snackbar);
    });

    const routeQuery = this.$route.query;
    if (routeQuery.sortBy && routeQuery.sortDirection) {
      this.currentSort = {
        column: routeQuery.sortBy,
        direction: routeQuery.sortDirection
      };
    }
  },
  methods: {
    handleSort(column, direction) {
      this.currentSort = {
        column: column,
        direction: direction
      };

      const query = { ...this.$route.query };

      if (column && direction) {
        query.sortBy = column;
        query.sortDirection = direction;
      } else {
        delete query.sortBy;
        delete query.sortDirection;
      }

      this.$router.push({ query });

      this.handlePage(1);
    },

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;
      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.sortBy && routeQuery.sortDirection) {
        const orderByArray = [{
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        }];

        tempFilters.push({
          key: 'orderBy',
          value: orderByArray
        });

        this.currentSort = {
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        };
      }

      gamificationService.getLeaderboards(page, tempFilters).then(response => {
        this.data = response.data.data;
        this.tableData = response.data.data;
        this.isLoading = false;
      })
    },
    loadTasks() {
      this.isTasksLoading = true;
      gamificationService.getGamificationTasks().then(response => {
        this.tasksData = response.data.data;
        this.isTasksLoading = false;
      }).catch(err => {
        handleErrorResponse(err, this.$snackbar);
        this.isTasksLoading = false;
      });
    },
    handleEditTask(task) {
      this.$snackbar.add({
        text: `${this.$t('editing')}: ${task.name}`,
        type: 'info'
      });
    },
    handleDeleteTask(taskId) {
      if (confirm(this.$t('confirm_delete_task'))) {
        this.$snackbar.add({
          text: this.$t('task_deleted_successfully'),
          type: 'success'
        });
        this.loadTasks();
      }
    },
    handleAddTask() {
      this.$snackbar.add({
        text: this.$t('add_task_feature_not_available'),
        type: 'info'
      });
    },
    handleTaskAddSuccess(newTask) {
      this.tasksData.push(newTask);

    }
  }
}
</script>

<style scoped>
.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.icon-holder img {
  cursor: default;
}
.table-holder {
  margin-top: 20px;
}
.table-holder .table {
  margin-top: 20px;
}
.tabs-container {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}
.tab {
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 500;
  color: #2f3640;
  transition: background-color 0.2s ease;
}

.tab.active {
  background-color: #f1f2f6; /* Ovalimsi soft gri */
}

.tasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.tasks-title {
  font-size: 20px;
  font-weight: 600;
  color: #101828;
}

.add-task-btn {
  display: flex;
  align-items: center;
  background-color: #0044FF;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-task-btn img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.add-task-btn:hover {
  background-color: #0036CC;
}
</style>
